import {html, TemplateResult} from "lit";

export class renderIconSet {
  public static createIconSet(iconName: string): TemplateResult {
    switch (iconName) {
      case 'link_company':
        return this.renderLinkCompany();
      case 'addlink_company':
        return this.renderAddLinkCompany();
      default:
        return html``;
    }
  }

  private static renderLinkCompany() {
    return html`
      <gz-icon size="24" color="var(--green-layout-100-primary-green)">
        <svg fill="none" viewBox="0 0 20 20" slot="custom-svg">
          <circle cx="10" cy="10" r="10"/>
          <path fill="var(--white-layout-300-primary)" d="M13.014 7C13.8405 7 14.5447 7.29446 15.1268 7.88337C15.7089 8.47229 16 9.17783 16 10C16 10.8222 15.7089 11.5277 15.1268 12.1166C14.5447 12.7055 13.8405 13 13.014 13H10.5916V11.8505H13.014C13.5212 11.8505 13.9578 11.6683 14.324 11.3038C14.6902 10.9394 14.8733 10.5048 14.8733 10C14.8733 9.49521 14.6902 9.06061 14.324 8.69617C13.9578 8.33174 13.5212 8.14952 13.014 8.14952H10.5916V7H13.014ZM7.60559 10.5885V9.41089H12.3944V10.5885H7.60559ZM5.12675 10C5.12675 10.5048 5.30983 10.9394 5.676 11.3038C6.04217 11.6683 6.47884 11.8505 6.98603 11.8505H9.40838V13H6.98603C6.15955 13 5.45526 12.7055 4.87315 12.1166C4.29105 11.5277 4 10.8222 4 10C4 9.17783 4.29105 8.47229 4.87315 7.88337C5.45526 7.29446 6.15955 7 6.98603 7H9.40838V8.14952H6.98603C6.47884 8.14952 6.04217 8.33174 5.676 8.69617C5.30983 9.06061 5.12675 9.49521 5.12675 10Z"/>
        </svg>
      </gz-icon>
    `
  }

  private static renderAddLinkCompany() {
    return html`
      <gz-icon size="24" color="var(--grey-layout-501-neutral-background)">
        <svg fill="none" viewBox="0 0 20 20" slot="custom-svg">
          <circle cx="10" cy="10" r="10"/>
          <path fill="var(--white-layout-300-primary)" d="M14.1971 10.0792V11.9208H16V13.1584H14.1971V15H13.0138V13.1584H11.2109V11.9208H13.0138V10.0792H14.1971ZM5.1268 10.0792C5.1268 10.5973 5.3099 11.0434 5.67608 11.4174C6.04227 11.7915 6.47897 11.9785 6.98618 11.9785H9.40865V13.1584H6.98618C6.15966 13.1584 5.45533 12.8561 4.8732 12.2517C4.29107 11.6472 4 10.9231 4 10.0792C4 9.23532 4.29107 8.51115 4.8732 7.90669C5.45533 7.30223 6.15966 7 6.98618 7H9.40865V8.17986H6.98618C6.47897 8.17986 6.04227 8.36689 5.67608 8.74095C5.3099 9.115 5.1268 9.56108 5.1268 10.0792ZM14.8732 10.0792C14.8732 9.56108 14.6901 9.115 14.3239 8.74095C13.9577 8.36689 13.521 8.17986 13.0138 8.17986H10.5913V7H13.0138C13.8403 7 14.5447 7.30223 15.1268 7.90669C15.7089 8.51115 16 9.23532 16 10.0792H14.8732ZM7.60577 9.47514H12.3948V10.6839H7.60577V9.47514Z"/>
        </svg>
      </gz-icon>
    `
  }
}
